<template>
  <router-link to="/teachers" tag="li"><a><i class="fa fa-users"></i><span>Aktivasi Guru</span></a></router-link>
</template>
<script>
export default {
  name: 'navigation-nav'
}
</script>





// WEBPACK FOOTER //
// Navigation.vue?3f80a2ef